<template>
    <SquareButton @click="replay">
        <Icon type="md-refresh" />
    </SquareButton>
</template>

<script lang="ts">
import SquareButton from "@/components/common/SquareButton.vue";

import bus from "@/bus";

import { PlaybackBannerActions } from "@/components/PlaybackControls/usePlaybackController";

export default {
    components: {
        SquareButton
    },

    props: {
        id: {
            type: String,
            required: true
        },

        playbackNamespace: {
            type: String,
            required: true
        }
    },

    methods: {
        replay() {
            bus.$emit(PlaybackBannerActions.ReplayBanner, { namespace: this.playbackNamespace, id: this.id });
        }
    }
};
</script>
